var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v(_vm._s(_vm.$t('privacyPage.title')))]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.$t('privacyPage.content'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }